 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		58: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + chunkId + "." + {"0":"4211b6b3659542cfb1ec","1":"1e63c5bc0418645bb7c6","2":"79a11da36bf9bc921545","3":"72abc096465a8d241ebf","4":"22cba545d4611a60bcb4","5":"fd83cd280eac7b8f9019","6":"265d41a80d7857c76064","7":"47866d636e866a31d612","8":"614cea57ed1ab1c03bae","9":"f5abafd3039276b0e3a7","10":"3d12ea006789213a101e","11":"8e9b48889521ea271351","12":"79e779b790ea3de9e1c4","13":"ffd5f4ab0833f8f82949","14":"cdd00d0934799b7c677f","15":"554e5683db8f9dd9c817","16":"f921d2a9095b2d215943","17":"fa228646d42f655c053d","18":"12090452bdcd45fef5d7","19":"79e4ed7573bcaff38e94","20":"7085032d1c0adebfb0f0","21":"5788e04a9c56cb7ffbce","22":"8095fafb89a623e288fd","23":"8c51e2ebdc1eb4f4e76a","24":"8e77574167034540a3e0","25":"e5fb44803127dbcbe38d","26":"72ade291c21bcd121ac7","27":"bdbb5849af16d9be4870","28":"211740e1003faec4dfda","29":"b343f5b6db748a2be0c9","30":"283313cb1129494fb209","31":"804bac25f8b13455ac3c","32":"43814f0754a5ea846177","33":"ccb7296109210d37c522","34":"9aba9af3299ba4fbc061","35":"92fccc353ad020be6596","36":"2a54127cab0f0eff8254","37":"fadd2586bc21c53a8fd3","38":"d3d9bbd802362df30a4f","39":"b65d8a9298325779afbb","40":"fe1fd11632ec10ef8cc9","43":"0ef6c778032487a409ea","44":"a689369672cc17e12c93","45":"cfb6dce2bf0e7f8b7036","46":"22b93ae77b85edf7dd6a","47":"7ee9533d03c810a67f5e","48":"87e12c248ec1cfe92a43","49":"f6e0b60b55aeb01aa404","50":"e935875ae7041e9d7f4f","51":"f9c8f08e3107524c699d","52":"3e19b263a025233f2689","53":"1ae538c773104941a5ec","54":"d2b071064697062d530e","55":"d326efad8d56f20aeb9a","56":"4f34098eb2675b095957","57":"106cc2c62c9d4ae5db58","60":"7540d96990bdfff76b29","61":"a382001fec3f31b42b4b","62":"bff0a065eaff012c4d01","63":"5fb3e35199c0302aef1e","64":"49098a993bf448fcbca6","65":"3bf48bbe15324c18753f","66":"3c554b7a85d11ac89ec3","67":"33820a821976cc885fd9","68":"7e7c6158f1f412db905c","69":"801f0f713ba9073062f5","70":"d1a311162bd0d9a5e5e8","71":"106c8c42e935ae955290","72":"ab6f314019005e37cfdd","73":"029c5d5c9c07233f08fa","74":"1c8618b924103f3359c6","75":"34b0a0aede3832ec36c1","76":"ea6389d81880e7d7ed73","77":"16410040ec322c75585c","78":"6a5998c2db3f42f0ec9f","79":"9b0d9da593bd80dfb97a","80":"35e4f02c154402f89cac","81":"99e79a44637e0528fcaf","82":"c763cee637a3b9ecab8e","83":"7eff7787dd03083e1cd2","84":"2c77cfe9a4d5c575fb4c","85":"8f1e6a737ccd4ea6bf5f"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://static.catalog.prod.coursedog.com/2f9c6b8/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
